module.exports = __webpack_public_path__ + "static/packeroo-08cb2b671ed2dcefe8ad42069f571464.png";